var collapsible_list_pair_rtlignore_default = {
  "container": "rigjI",
  "title": "ZJF7t",
  "viewerContainer": "qRvXG",
  "titleContainer": "-J-7I",
  "expandIcon": "_2Hwkd",
  "dndIcon": "bNDGW",
  "RTL": "N22r2",
  "LTR": "VJ0rM",
  "itemContainer": "BAc2j",
  "itemContainerViewer": "sZQzw",
  "mouseDown": "D8kdm",
  "innerEditor": "lvCVU",
  "item": "AMqrQ",
  "floatingAddPluginMenuWrapper": "JTbh0",
  "childrenHidden": "kAG-7"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
